<app-page-header header="conclusion.title"></app-page-header>

<qbe-panel-component>
  <ng-container [ngSwitch]="selectProcessSavedOfferState$ | async">
    <app-error *ngSwitchCase="apiState.error" [appError]="selectProcessSavedOfferError$ | async"></app-error>
    <ng-container *ngSwitchCase="apiState.success">
      <nx-message context="success" class="save-offer-toast">
        <div class="save-offer-toast-content">
          <span>
            {{ 'conclusion.save-offer-toast.title' | translate }} {{ selectProcessSavedOfferPolicyNumber$ | async }}
          </span>
          <a [href]="'/' + globtroterApp + '/search-policy?polnum=' + (selectProcessSavedOfferPolicyNumber$ | async)" class="md-link save-offer-toast-link" target="_parent">
            <nx-icon name="arrow-right" size="s" class="nx-margin-right-2xs"></nx-icon>
            {{ 'conclusion.save-offer-toast.link' | translate }}
          </a>
        </div>
      </nx-message>
    </ng-container>
  </ng-container>
  <div nxRow class="page-container">
    <div nxCol="12,12,6,6">
      <h2 nxHeadline="section" class="page-headline">
        {{ "conclusion.headline" | translate }}
      </h2>

      <div class="page-illustration">
        <qbe-illustration name="clientAndAgentShakingHands"></qbe-illustration>
      </div>
    </div>
    <div nxCol="12,12,6,6">
      <app-radio-buttons [options]="horizontalButtons" [selected]="conclusion$ | async" (change)="handleChange($event)" />
    </div>
  </div>
</qbe-panel-component>
